<div class="section-list card">
    <div class="card-header">
        <nav class="navbar navbar-expand-sm navbar-light navbar-section-header justify-content-between section-header">
            <span class="navbar-brand mb-0 h1"><i class="fas fa-list"></i> Sites</span><span
                class="badge badge-primary">{{listFiltered.length}}</span>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <div class="ml-auto d-flex justify-content-end">
                    <!-- <app-site-filter #filterbysite [automaticLoad]="false" [mylist]="list" [myplaceholder]="'By Site'" ></app-site-filter> -->

                    <ul class="nav navbar-nav ml-auto">
                        <li class="nav-item">
                            <div class="search-container">
                                <i class="fa fa-search search-icon"></i>
                                <input class="form-control form-control-sm search-box" type="text"
                                    (input)="tableFilter($event)" placeholder="Filter">
                            </div>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" role="button" (click)="refresh();false" matTooltip="Refresh list">
                                <i class="fas fa-sync"></i>
                            </a>
                        </li>
                        <li class="nav-item dropdown" dropdown placement="bottom right">
                            <a class="nav-link dropdown-toggle" data-toggle="dropdown" role="button"
                                aria-haspopup="true" aria-expanded="false" dropdownToggle (click)="false">
                                <i class="fas fa-ellipsis-v"></i>
                            </a>
                            <div class="dropdown-menu dropdown-menu-right" *dropdownMenu
                                aria-labelledby="simple-dropdown1">
                                <!-- <div class="dropdown-header">Supervision</div> -->
                                <a class="dropdown-item" (click)="newSite();false" matTooltip="Create new site"> <i
                                        class="far fa-plus-square"></i> New Site</a>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    </div>
    <div class="card-body nopadding">
        <mat-progress-bar mode="indeterminate" *ngIf="loadinglist"></mat-progress-bar>
        <app-frms-messagebar *ngIf="alertmessage" [alertmessage]="alertmessage"></app-frms-messagebar>
        <div class="map-container">
            <app-site-list-map #sitelistmap [siteList]="listFiltered" [autoLoad]="false"
                (siteClickedEvent)="siteClickedEventHandler($event)"></app-site-list-map>
        </div>

        <div class="app-table pointer">
            <p-table #frtable [value]="listFiltered" sortMode="multiple"
                [globalFilterFields]="['name','company.name','info.zone','info.power','info.countryFull2']"
                [scrollable]="true" scrollHeight="79vh">
                <ng-template pTemplate="header">
                    <tr>
                        <th *ngIf="ui_showCompany" [pSortableColumn]="'company.name'" class="td-companyname">Company
                            <p-sortIcon [field]="'company.name'"></p-sortIcon>
                        </th>
                        <th [pSortableColumn]="'name'">Site
                            <p-sortIcon [field]="'name'"></p-sortIcon>
                        </th>
                        <th [pSortableColumn]="'info.power'">Power
                            <p-sortIcon [field]="'info.power'"></p-sortIcon>
                        </th>
                        <th [pSortableColumn]="'info.zone'">Zone
                            <p-sortIcon [field]="'info.zone'"></p-sortIcon>
                        </th>
                        <th [pSortableColumn]="'info.countryFull2'">Country
                            <p-sortIcon [field]="'info.countryFull2'"></p-sortIcon>
                        </th>
                        <th [pSortableColumn]="'info.updating_date'">Last update
                            <p-sortIcon [field]="'info.updating_date'"></p-sortIcon>
                        </th>
                        <th class="td-col-actions">

                        </th>

                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-row>
                    <tr (click)="openitem(row)">
                        <td *ngIf="ui_showCompany" class="td-companyname">{{row.company?.name}}</td>
                        <td>{{row.name}}</td>
                        <td>{{row.info?.power | watts:1000000}}</td>
                        <td>{{uigetZone(row)}}</td>
                        <td>
                            <frms-flag-icon [country]="uigetCountryCC2(row)"></frms-flag-icon> {{row.info.countryFull2}}
                        </td>
                        <td>{{row.info?.updating_date | date:'dd-MM-yyyy HH:mm' }}</td>
                        <td (click)="$event.stopPropagation()" class="td-col-actions-hoverable1">
                            <div class=" td-actions text-right">
                                <button type="button" class="btn btn-sm btn-outline-secondary"
                                    [matMenuTriggerFor]="menu">
                                    <i class="fas fa-ellipsis-v"></i>
                                </button>
                                <mat-menu #menu="matMenu" class="">
                                    <div mat-menu-item
                                        *permusr="{id:controlEnum.BTN_SITE_EDIT, authFunction:acl_btn_bysite(controlEnum.BTN_SITE_EDIT,row)}">
                                        <a class="dropdown-item" (click)="openitem(row)">
                                            <i class="fas fa-pen"></i> Edit site
                                        </a>
                                    </div>
                                    <div mat-menu-item
                                        *permusr="{id:controlEnum.BTN_SUPERVISION_EDIT, authFunction:acl_btn_bysite(controlEnum.BTN_SUPERVISION_EDIT,row)}">
                                        <a class="dropdown-item" (click)="newsupervision(row);false">
                                            <i class="far fa-plus-square"></i> New Supervision
                                        </a>
                                    </div>
                                    <div mat-menu-item
                                        *permusr="{id:controlEnum.BTN_SITE_DELETE, authFunction:acl_btn_bysite(controlEnum.BTN_SITE_DELETE,row)}">
                                        <a class="dropdown-item text-danger" [routerLink]=""
                                            (click)="openDialogDeleteSite(row)">
                                            <i class="far fa-trash-alt"></i> Delete site
                                        </a>
                                    </div>
                                </mat-menu>
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>